import { Directive, ElementRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  selector: '[appRouterlinkinterceptor]'
})
export class RouterlinkinterceptorDirective {

  constructor(private el:ElementRef,private router:Router) { }

  @HostListener('click',['$event'])
  onClick(event:Event){
    const target = event.target as HTMLElement;

    if(target.tagName === 'A'){
      const href = (target as HTMLAnchorElement).getAttribute('href');
      if (href && href.startsWith('/')){
        event.preventDefault();
        this.router.navigateByUrl(href);
      }
    }
  }

}
